import {
  stakingGetPlansUrl,
  stakingMyStakesUrl,
  stakingStakeUrl,
  stakingClaimUrl,
  launchpadAddUrl,
  launchpadListingUrl,
  launchpadBuyUrl,
  launchpadMyPurchasesUrl,
  listingAddUrl,
  listingTodayUrl,
  listingUpcomingUrl,
  listingMyUrl,
  contactUsQueryUrl,
} from "../constant/Api";
import { baseApi } from "./api";

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Staking
    stakingGetPlans: builder.query({
      query: () => ({
        url: stakingGetPlansUrl,
        method: "GET",
      }),
    }),

    stakingMyStakes: builder.query({
      query: () => ({
        url: stakingMyStakesUrl,
        method: "GET",
      }),
    }),

    stakingStake: builder.mutation({
      query: (body) => ({
        url: stakingStakeUrl,
        method: "POST",
        body,
      }),
    }),

    stakingClaim: builder.mutation({
      query: (body) => ({
        url: stakingClaimUrl,
        method: "POST",
        body,
      }),
    }),

    // Launchpad

    launchpadAdd: builder.mutation({
      query: (body) => ({
        url: launchpadAddUrl,
        method: "POST",
        body,
      }),
    }),

    launchpadListing: builder.query({
      query: () => ({
        url: launchpadListingUrl,
        method: "GET",
      }),
    }),

    launchpadBuy: builder.mutation({
      query: ({ launchpadId, ...body }) => ({
        url: launchpadBuyUrl(launchpadId),
        method: "POST",
        body,
      }),
    }),

    launchpadMyPurchases: builder.query({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: `${launchpadMyPurchasesUrl}?page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),

    // Listing
    listingAdd: builder.mutation({
      query: (body) => ({
        url: listingAddUrl,
        method: "POST",
        body,
      }),
    }),

    listingToday: builder.query({
      query: () => ({
        url: listingTodayUrl,
        method: "GET",
      }),
    }),

    listingUpcoming: builder.query({
      query: () => ({
        url: listingUpcomingUrl,
        method: "GET",
      }),
    }),

    listingMy: builder.query({
      query: () => ({
        url: listingMyUrl,
        method: "GET",
      }),
    }),

    // Contact Us
    contactUs: builder.mutation({
      query: (body) => ({
        url: contactUsQueryUrl,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useStakingGetPlansQuery,
  useStakingMyStakesQuery,
  useStakingStakeMutation,
  useStakingClaimMutation,
  useLaunchpadAddMutation,
  useLaunchpadListingQuery,
  useLaunchpadBuyMutation,
  useLaunchpadMyPurchasesQuery,
  useListingAddMutation,
  useListingTodayQuery,
  useListingUpcomingQuery,
  useListingMyQuery,
  useContactUsMutation,
} = userApi;
